import { useEffect, useState, useContext } from 'react';
import { IconButton, CircularProgress } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Context } from '../../../AuthContext';
import UnifiedModal from './UnifiedModal';

const TasksSummary = ({ onOpenTaskManager }) => {
  const { user } = useContext(Context);
  const [summary, setSummary] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchSummary = async () => {
    if (!user?.uid) return;
    setLoading(true);
    try {
      const token = await user.getIdToken();
      const res = await fetch(process.env.REACT_APP_FLASK_WEBSERVER + 'get_tasks_summary', {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) return;
      const data = await res.json();
      setSummary(data);
    } catch (err) {
      console.error('Failed to fetch tasks summary', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, [user?.uid]);

  const handleSave = () => {
    setOpenModal(false);
    fetchSummary();
  };

  const dueToday = summary?.due_today ?? 0;
  const upcoming = summary?.due_future ?? 0;
  const overdue = summary?.overdue ?? 0;

  return (
    <div
      style={{
        padding: '12px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '12px',
          fontWeight: 600,
          minWidth: 0,
        }}
      >
        <img src="/task.svg" alt="" style={{ flexShrink: 0 }} />
        <span
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            minWidth: 0,
          }}
        >
          PERSONAL TASKS
        </span>
      </div>
      <div
        style={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        {loading ? (
          <CircularProgress size={24} style={{ color: '#000' }} />
        ) : (
          <>
            <div
              onClick={onOpenTaskManager}
              style={{
                fontSize: '18px',
                fontWeight: 700,
                textDecoration: 'underline',
                cursor: onOpenTaskManager ? 'pointer' : 'default',
              }}
            >
              {dueToday} DUE TODAY
            </div>
            <div>{upcoming} Upcoming</div>
            <div>{overdue} Overdue</div>
          </>
        )}
      </div>
      <div
        style={{
          color: '#1976d2',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '4px',
          cursor: 'pointer',
          marginBottom: '12px',
        }}
        onClick={() => setOpenModal(true)}
      >
        <IconButton size="small" sx={{ color: '#1976d2' }}>
          <AddCircleIcon fontSize="small" />
        </IconButton>
        Add Task
      </div>

      <UnifiedModal
        open={openModal}
        handleClose={() => setOpenModal(false)}
        item={null}
        type="task"
        onSave={handleSave}
      />
    </div>
  );
};
export default TasksSummary;
